import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { rootSiteSelector, siteFromRootSiteSelector } from 'selectors/root-site';
import { initGA, initFBPixel } from 'configurations/analytics-manager';
import { isMobileViewport } from 'utils/responsive';

const scriptTimeout = isMobileViewport() ? 4000 : 3000;

const AnalyticsProvider = () => {
  const { siteSlug } = useParams();

  const { googleAnalyticsId, metaPixelId } = useSelector(
    siteSlug ? siteFromRootSiteSelector(siteSlug) : rootSiteSelector,
  );

  useEffect(() => {
    if (!googleAnalyticsId) return;

    const timeoutId = setTimeout(() => {
      initGA(googleAnalyticsId);
    }, scriptTimeout);
    return () => clearTimeout(timeoutId);
  }, [googleAnalyticsId, siteSlug]);

  useEffect(() => {
    if (!metaPixelId) return;

    const timeoutId = setTimeout(() => {
      initFBPixel(metaPixelId);
    }, scriptTimeout);
    return () => clearTimeout(timeoutId);
  }, [metaPixelId, siteSlug]);

  return null;
};

export default AnalyticsProvider;
